/**
 * API Configuration for Taza Tropics Application
 */

const isDevelopment = process.env.NODE_ENV === 'development';

export const API_CONFIG = {
  // Use proxy path in development, direct URL in production
  BASE_URL: isDevelopment ? '/public/api/v1/' : 'https://api.tazatropics.com/public/api/v1/',
  IMAGE_URL: 'https://api.tazatropics.com/public/storage/images/',
};

export const API_ENDPOINTS = {
  // Categories
  CATEGORIES: {
    GET_HOME: 'category/getHome',
    GET_ALL: 'categories/getAll',
  },
  // Products
  PRODUCTS: {
    SEARCH_QUERY: 'products/searchQuery',
    GET_BY_ID: 'products/getById',
    GET_BY_STORE_ID: 'products/getByStoreId',
    GET_BY_CATEGORY: 'products/getByCategoryId',
    GET_BY_SUBCATEGORY: 'products/getBySubCategoryId',
  },
  // Home
  HOME: {
    SEARCH_WITH_CITY: 'home/searchWithCity',
    SEARCH_WITH_GEO: 'home/searchWithGeoLocation',
    SEARCH_WITH_ZIP: 'home/searchWithZipCode',
  },
  // Cities
  CITIES: {
    GET_ALL: 'cities/getAll',
  },
  // Cart Management
  CART: {
    VALIDATE_COUPON: 'coupons/validate',
    SYNC: 'cart/sync',
  },
  // Orders
  ORDERS: {
    CREATE: 'orders/create',
    GET_BY_UID: 'orders/getByUid',
  },
  // Addresses
  ADDRESS: {
    GET_BY_UID: 'address/getByUid',
    ADD_NEW: 'address/addNew',
  },
  // Utilities
  UTILITIES: {
    GET_SETTINGS: 'settings/getDefaultWeb',
    GET_COUPONS: 'coupons/getAll',
  },
};

export default API_CONFIG;